import type {ThesaurusMap} from '../types';
import {useAllThesaurusIds} from './useAllThesaurusIds';
import {useThesaurusMap} from './useThesaurusMap';

export const useAllThesaurusMap = (): ThesaurusMap => {
  const theusaurusIds = useAllThesaurusIds();

  return useThesaurusMap(theusaurusIds);
};
